// Copied from https://github.com/gregberge/react-merge-refs/blob/812fefa4390884a4a2d1bc489d869bd088df8ff5/src/index.tsx
// `react-merge-refs` lib exports only ES modules, which caused issues in projects
// consuming this component. E.g. Jest imports happily only CJS modules.
export function mergeRefs(refs) {
    return function (value) {
        refs.forEach(function (ref) {
            if (typeof ref === 'function') {
                ref(value);
            }
            else if (ref != null) {
                ref.current = value;
            }
        });
    };
}
//# sourceMappingURL=mergeRefs.js.map